const PREFIX = 'bravissimo/product-listing/';

export const RECEIVE_PRODUCT_LISTING = `${PREFIX}RECEIVE_PRODUCT_LISTING`;
export const RECEIVE_PRODUCT_LISTING_FAILURE = `${PREFIX}RECEIVE_PRODUCT_LISTING_FAILURE`;
export const RECEIVE_PRODUCT_LISTING_REQUEST = `${PREFIX}RECEIVE_PRODUCT_LISTING_REQUEST`;
export const SELECT_STYLE_COLOUR = `${PREFIX}SELECT_STYLE_COLOUR`;
export const CLEAR_SCROLL = `${PREFIX}CLEAR_SCROLL`;
